export const state = {
  entrepriseSelector: undefined,
  entrepriseSelectors: [],
  pagination: { size: 25 },
  filter: {
    query: ''
  }
}